import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { IAddLead, ILead } from '../../Lead.props';

const useEditLead = (leadId: string, setMethod: () => void) => {
  const [formData, setFormData] = useState<IAddLead>({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    description: "",
    linkedin: "",
    interest: "",
    outputStatus: "",
    services: "",
    platform: "",
    CPLinkedInProfile:""
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [lead, setLead] = useState<ILead | null>(null);
  const [interest, setInterest] = useState<any[]>([]);
  const [interestId, setInterestId] = useState<string>("");
  const [services, setServices] = useState<any[]>([]);
  const [serviceId, setServiceId] = useState<string>("");
  const [outputStatuses, setOutputStatuses] = useState<any[]>([]);
  const [outputStatusId, setOutputStatusId] = useState<string>("");
  const [platforms, setPlatforms] = useState<any[]>([]);
  const [platformId, setPlatformId] = useState<string>("");
  const [lookingFor, setLookingFor] = useState<string>('Individual');
  useEffect(() => {
    fetchData();
    fetchInterestsData();
    fetchServicesData();
    fetchOutputStatusesData();
    fetchPlatformsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getAllLeads}/${leadId}`,
      });
      // const data = response.data.find(
      //   (lead: { _id: any }) => lead?._id === leadId || null
      // );
      console.log(response)
      setLead(response);
      populateFormData(response);
    } catch (error) {
      console.log(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchInterestsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.interests}`,
      });
      setInterest(result);
    } catch (error) {
      console.error("Error fetching interests:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchServicesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.services}`,
      });
      setServices(result);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOutputStatusesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.outputStatus}`,
      });
      setOutputStatuses(result);
    } catch (error) {
      console.error("Error fetching output statuses:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPlatformsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.platforms}`,
      });
      setPlatforms(result);
    } catch (error) {
      console.error("Error fetching platforms:", error);
    } finally {
      setLoading(false);
    }
  };
  const populateFormData = (leadData: ILead) => {
    console.log(leadData, "leadData")
    setFormData({
      name: leadData.name,
      email: leadData.email || "",
      phone: leadData.phone || "",
      companyName: leadData.companyName || "",
      description: leadData.description || "",
      linkedin: leadData.linkedin || "",
      interest: leadData.interest?._id,
      outputStatus: leadData.outputStatus?._id,
      services: leadData.services?._id,
      platform: leadData.platform?._id,
      CPLinkedInProfile:leadData.CPLinkedInProfile
    });
    setInterestId(leadData.interest?._id || "");
    setOutputStatusId(leadData.outputStatus?._id || "");
    setServiceId(leadData.services?._id || "");
    setPlatformId(leadData.platform?._id || "");
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit: SubmitHandler<IAddLead> = async () => {
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateLead}${leadId}`,
        data: {
          ...formData,
          interest: interestId,
          outputStatus: outputStatusId,
          services: serviceId,
          platform: platformId,
          lookingFor: lookingFor,
        },
      });
      if (response !== "undefined") {
        toast.success("Lead updated successfully", {
          duration: 5000,
        });
        setTimeout(() => {
          setMethod();
        }, 1500);
      }
    } catch (error:any) {
      toast.error(`Error - ${error.response.data.error || error}`, {
        duration: 5000,
      });
      console.error("Error updating lead:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    formData,
    lead,
    handleChange,
    handleSubmit,
    setInterestId,
    setLookingFor,
    lookingFor,
    interest,
    interestId,
    services,
    serviceId,
    setServiceId,
    outputStatuses,
    outputStatusId,
    setOutputStatusId,
    platforms,
    platformId,
    setPlatformId,
  };
};
export default useEditLead;
